/* assets/shop.js: THE SHOP PAGE (decision 130), live 2026-10-15, ported from the harness's _ab-shop/f.js unchanged. Loaded on
   the product template only, after product.js (layout/theme.liquid). The harness's note follows. */
/* _ab-shop/f.js: SHOP PAGE F (2026-10-15), page E in the house design language: e.js unchanged, so every button, reel, price
   and dialog behaves as on E. The parts of D's and A's scripts that E's sections use, verbatim: from d.js its buttons (every
   red button leads to the buy section) and its reels; from a.js its prices (the comparison's per-serving figure and the deal's
   prices), its jumps (the deal's Shop MOG; the reviews' went at Ashot's word) and its label viewer. Never their sticky bars.
   The hand-off is the theme's own assets/handoff.js, which the live key and FAQ load. */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia ? matchMedia('(max-width: 899px)') : { matches: innerWidth < 900 };
  var BAR_H = 64;   /* the header bar's height; #buy carries the same scroll-margin-top in base.css */

  function each(sel, fn, root) { [].forEach.call((root || doc).querySelectorAll(sel), fn); }
  function jump(y) {   /* an instant scroll, whatever html's scroll-behavior says */
    var was = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = was;
  }


  /* ---------- 2. every red button leads to the buy section ---------- */
  each('[data-sv-d-go]', function (a) {
    a.addEventListener('click', function (e) {
      var buy = doc.getElementById('buy'); if (!buy) return;
      e.preventDefault();
      var mark = doc.getElementById('pdp-pack-l') || buy;
      var y = Math.max(0, mark.getBoundingClientRect().top + window.scrollY - BAR_H - 14);
      if (still) jump(y); else window.scrollTo({ top: y, behavior: 'smooth' });
      var pick = doc.querySelector('#mog-buy input[name="size"]:checked') || doc.querySelector('#mog-buy [name="add"]');
      if (pick && pick.focus) pick.focus({ preventScroll: true });
    });
  });

  /* ---------- 3. the reels ---------- */
  (function reels() {
    var wall = doc.querySelector('[data-sv-d-wall]'); if (!wall) return;
    var sec = wall.closest('section') || wall.parentNode;
    var cards = [].slice.call(wall.querySelectorAll('.sv-d-reel'));
    var snd = sec.querySelector('[data-sv-d-snd]');
    var vid = null, cur = -1, near = false, chosen = false, settleT = 0;

    function media() {
      if (vid) return vid;
      vid = doc.createElement('video');
      vid.className = 'sv-d-reel__vid';
      vid.muted = true; vid.defaultMuted = true; vid.setAttribute('muted', '');
      vid.loop = true; vid.playsInline = true; vid.setAttribute('playsinline', '');
      vid.preload = 'none';
      vid.setAttribute('aria-hidden', 'true');
      vid.tabIndex = -1;
      ['playing', 'pause', 'volumechange', 'emptied'].forEach(function (ev) { vid.addEventListener(ev, paint); });
      return vid;
    }
    function paint() {
      cards.forEach(function (c, i) {
        var on = i === cur;
        c.classList.toggle('is-on', on && chosen);
        c.classList.toggle('is-playing', on && !!vid && !vid.paused);
      });
      if (!snd) return;
      var live = cur > -1 && !!vid && !!vid.getAttribute('src');
      snd.hidden = !live;
      if (!live) return;
      var loud = !vid.muted && !vid.paused;
      snd.classList.toggle('is-on', loud);
      snd.setAttribute('aria-pressed', loud ? 'true' : 'false');
      snd.setAttribute('aria-label', loud ? 'Turn sound off' : 'Turn sound on');
    }
    function take(i) {
      var v = media();
      if (i === cur) return v;
      if (!v.paused) v.pause();
      cur = i;
      var c = cards[i];
      c.insertBefore(v, c.querySelector('.sv-d-reel__go'));
      if (snd) c.appendChild(snd);
      v.removeAttribute('src'); v.load();
      v.src = c.getAttribute('data-src');
      return v;
    }
    function play(i, sound) {
      var v = take(i);
      v.muted = !sound;
      var p = v.play();
      if (p && p.then) p.then(paint, function () {
        /* a browser that refuses sound still lets it roll muted, the sound button one tap away */
        if (sound) { v.muted = true; var q = v.play(); if (q && q.then) q.then(paint, paint); }
        paint();
      });
      paint();
    }
    /* the reel a phone has snapped into place: the one nearest the scroller's start padding */
    function lead() {
      if (!phone.matches) return 0;
      var start = wall.getBoundingClientRect().left + parseFloat(getComputedStyle(wall).paddingLeft || 0);
      var best = 0, bd = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - start); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function preview() { if (!still && !chosen && near) play(lead(), false); }

    cards.forEach(function (c, i) {
      c.querySelector('.sv-d-reel__go').addEventListener('click', function () {
        chosen = true;
        var v = media();
        if (i !== cur) { play(i, true); return; }
        if (v.paused) { v.muted = false; var p = v.play(); if (p && p.then) p.then(paint, paint); }
        else if (v.muted) v.muted = false;
        else v.pause();
        paint();
      });
    });
    if (snd) snd.addEventListener('click', function () {
      if (cur < 0) return;
      chosen = true;
      var v = media();
      if (v.muted || v.paused) { v.muted = false; if (v.paused) { var p = v.play(); if (p && p.then) p.then(paint, paint); } }
      else v.muted = true;
      paint();
    });
    /* a swipe on the phone's wall moves the muted preview to the reel that lands */
    wall.addEventListener('scroll', function () {
      clearTimeout(settleT);
      settleT = setTimeout(function () { if (!chosen && near && lead() !== cur) preview(); }, 180);
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          near = e.isIntersecting;
          if (near) preview();
          else if (vid && !vid.paused) vid.pause();   /* off screen it stops; it only comes back muted, never with sound */
        });
      }, { threshold: 0.5 }).observe(wall);
    }
    paint();
  })();

})();

(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function set(key, value) { $$('[data-sva="' + key + '"]').forEach(function (el) { el.textContent = value; }); }

  var form = document.getElementById('mog-buy');
  var card = form ? form.querySelector('[name="add"]') : null;
  var data = null;
  try { data = JSON.parse($('#buy [data-buy-data]').textContent); } catch (e) { data = null; }

  /* ---------- 1. prices ---------- */
  function byId(id) {
    var list = (data && data.variants) || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }
  var packs = form ? $$('input[name="size"]', form) : [];
  var oneIn = packs.filter(function (p) { return p.getAttribute('data-tins') === '1'; })[0] || null;
  var dealIn = (form && $('.pdp-pack--deal input[name="size"]', form)) || packs.filter(function (p) { return Number(p.getAttribute('data-tins')) > 1; })[0] || null;
  var one = oneIn ? byId(oneIn.value) : null;
  var deal = dealIn ? byId(dealIn.value) : null;

  /* the head-to-head's per-serving figure: the one-tin pack's, as the science page prints it */
  if (one && one.serving) set('each', one.serving);
  else $$('[data-sva-row="each"]').forEach(function (r) { r.hidden = true; });

  /* the deal, in the card's own words for its row (name, size, per serving, saving, note) and its own prices */
  if (deal && dealIn) {
    var row = dealIn.closest('.pdp-pack');
    var lines = row ? $$('.pdp-pack__d > span', row) : [];
    /* the deal's name without the card's mint count (2026-10-19: the card's title is "Buy 2 Get 1 Free (180 Mints)" and this
       section prints its own size line) */
    set('deal-name', text(row && ($('.pdp-pack__nm', row) || $('.pdp-name', row))) || 'Buy 2 Get 1 Free');
    set('deal-size', text(lines[0]));
    set('deal-price', deal.price || '');
    set('deal-was', deal.compare || '');
    set('deal-serving', text(lines[1]));
    set('deal-save', text(lines[2]));
    set('deal-note', text(row && $('.pdp-pack__note', row)));
    /* the deal on subscription: its plan's price and percentage. The card's renewal sentence is not restated here:
       it is a CLAIMS FLAG for a renewal the store does not make yet (decision 125), and the card already carries it. */
    var plan = deal.plans && deal.plans[0];
    if (plan) {
      set('sub-tag', 'Extra ' + plan.pct + '% off');
      set('sub-price', plan.price || '');
      set('sub-perk', 'An extra ' + plan.pct + '% off every order');
    } else {
      $$('[data-sva="sub"]').forEach(function (b) { b.hidden = true; });
    }
  }

  /* ---------- 3. the jumps: to the top, where the buy card is, with focus on its button (the closing section's
     own behaviour on this template). Without this script the anchor still lands on #buy. ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-sva-buy]') : null;
    if (!a || !$('#buy')) return;
    e.preventDefault();
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: calm ? 'instant' : 'smooth' });
    if (card && card.focus) card.focus({ preventScroll: true });
  });


  /* ---------- 4. the label ---------- */
  var dlg = $('[data-sva-dialog]');
  if (dlg) {
    $$('[data-sva-facts]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    });
    var x = $('[data-sva-close]', dlg);
    if (x) x.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
  }


  /* ---------- 5. the Verified mark on the featured review (2026-10-17) ----------
     Ashot: "For my featured review make sure it carries over the "Verified" label from the reviews above. This is very
     important". The box's words are typed (sections/shop-reviews.liquid), but the mark is the review app's flag and never
     hardcoded (base.css, above .rev__ok). The box names its judge.me review by uuid; this reads the public endpoint
     assets/reviews.js reads (its shop and product from the same [data-rev-config]), and appends reviews.js's own mark to
     the box's by-line only when judge.me says that review is a verified buyer, read the way reviews.js reads it. With no
     answer, no mark. */
  var revBoxes = $$('.sv-a-rev [data-jdgm-review]'), revCfg = $('[data-rev-config]');
  if (revBoxes.length && revCfg && window.fetch) {
    var cfg = (revCfg.getAttribute('data-rev-config') || '').split('|');
    var SHOP = (cfg[0] || '').replace(/"/g, ''), PID = cfg[1];
    var API = revCfg.getAttribute('data-rev-api') || 'https://api.judge.me';
    var wanted = {}, left = 0;
    revBoxes.forEach(function (b) { wanted[b.getAttribute('data-jdgm-review')] = b; left++; });
    var read = function (n) {
      var p = 'shop_domain=' + encodeURIComponent(SHOP) + '&platform=shopify&product_id=' + encodeURIComponent(PID) +
              '&json_request=true&page=' + n + '&per_page=20';
      return fetch(API + '/reviews/reviews_for_widget?' + p, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('reviews ' + r.status); return r.json(); })
        .then(function (d) {
          (d.reviews || []).forEach(function (r) {
            var box = r && wanted[r.uuid];
            if (!box) return;
            delete wanted[r.uuid]; left--;
            var rv = r.reviewer || {};
            var by = $('.sv-a-card__by', box);
            if (!(r.verified_buyer || rv.verified_buyer || r.verified === 'buyer') || !by || $('.rev__ok', by)) return;
            var ok = document.createElement('span');
            ok.className = 'rev__ok';
            ok.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 6.4 4.3 9.6 11 2.4"/></svg>';
            ok.appendChild(document.createTextNode('Verified'));
            by.appendChild(ok);
          });
          if (left > 0 && n * 20 < (Number(d.number_of_reviews) || 0) && n < 10) return read(n + 1);
        });
    };
    read(1).catch(function () {});
  }

})();
